let activeGender = "men"; let hiddenGender = "women"; 

if(window.location.href.toLowerCase().includes("women") || window.location.href.toLowerCase().includes("woman") ||
 ( getCookie('personalize') === 'women' && window.location.pathname === '/') ){
  activeGender = "women"; hiddenGender = "men";
  document.querySelector(`.featured-companies`).dataset.activeGender = "women";
}else{
  activeGender = "men"; hiddenGender = "women";
  document.querySelector(`.featured-companies`).dataset.activeGender = "men";
}



var slider = new KeenSlider(`.featured-companies__container-${activeGender} #featured-companies__quotes--slider`, {
  loop: true,
},
[navigation],
[
  (slider) => {
    let timeout
    let mouseOver = false
    function clearNextTimeout() {
      clearTimeout(timeout);
    }
    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next();
      }, 10000)
    }
    slider.on("created", () => {
      slider.container.addEventListener("mouseover", () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener("mouseout", () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on("dragStarted", clearNextTimeout)
    slider.on("animationEnded", nextTimeout)
    slider.on("updated", nextTimeout)
  },
]);
var thumbnails = new KeenSlider(
  `.featured-companies__container-${activeGender} #featured-company__thumbnails--slider`,
  {
    initial: 0,
    spacing: 10,
    breakpoints: {
      '(max-width: 449px)': {
        slides: {
          perView: 2.5
        }
      },
      '(min-width: 450px)': {
        slides: {
          perView: 3.5
        }
      },
      '(min-width: 750px)': {
        slides: {
          perView: 5
        }
      },
    },
  },
  [ThumbnailPlugin(this.slider)]
)

// Prevent layout shifting
document.querySelectorAll(`.featured-companies__container-${activeGender} .featured-company__thumbnails .keen-slider__slide`).forEach(el => el.style.display = 'block');

document.querySelector(`.featured-companies__container-${hiddenGender}`).classList.add('hidden');


document.querySelector(`.featured-companies__container-${activeGender}`).classList.remove('loading');
document.querySelector(`.featured-companies__container-${hiddenGender}`).classList.remove('loading');
 